import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import * as all from '../util/all';

// import Button from '@mui/material/Button';
// import { useState } from 'react';
// import Menu from '@mui/material/Menu';
// import MenuItem from '@mui/material/MenuItem';
// import Typography from '@mui/material/Typography';
import { Tour, TourType } from '@/_models/Tour';

export const NavigationHeader = ({ rtl, isBackgroundVisible, tour, tourType }: { rtl: boolean; isBackgroundVisible: boolean; tour: Tour; tourType: TourType }) => {
  // const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  // const open = Boolean(anchorEl);
  // const handleClick = (event: React.MouseEvent<HTMLElement>) => {
  //   setAnchorEl(event.currentTarget);
  // };

  // const handleClose = () => {
  //   setAnchorEl(null);
  // };

  return (
    <AppBar
      position="static"
      sx={{
        background: isBackgroundVisible && tourType === TourType.Kiosk ? '#fff' : 'transparent',
        borderBottom: isBackgroundVisible ? '1px solid #D0D5DD' : 'none',
        height: '77px',
        boxShadow: 'none',
        display: { xs: 'none', lg: 'flex' },
        visibility: !isBackgroundVisible && tourType === TourType.Regular ? 'hidden' : 'visible',
      }}
    >
      <Toolbar
        sx={{
          width: '100%',
          height: 'inherit',
          p: '15px 20px',
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        {tour.client && tour.client.logo && (
          <img width="133px" height="46px" src={`${process.env.REACT_APP_AWS}/clients/${tour.client.id}/logo.png${all.getVersion(tour.client.updatedAt)}`} alt="" />
        )}
        {/* LANGUAGE MEN HIDDEN FOR NOW */}
        {/* <Button
          id="lang-button"
          aria-controls={open ? 'lang-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          variant="contained"
          disableElevation
          onClick={handleClick}
          endIcon={<i className="fa-solid fa-chevron-down" style={{ fontSize: '18px', fontWeight: 500 }} />}
          sx={{
            width: '166px',
            height: '47px',
            borderRadius: '8px',
            border: '1px solid #D0D5DD',
            background: '#FFF',
            pr: 0,
            color: '#000',
            '&:hover': {
              background: '#FFF',
              color: '#000',
            },
            '&:focus': {
              border: '1px solid #D0D5DD',
            },
            '.MuiButton-endIcon': {
              marginLeft: 'auto',
              marginRight: '0',
              width: '38px',
              borderLeft: '1px solid #D0D5DD',
              height: 'inherit',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            },
          }}
        >
          <Typography width="108px">English</Typography>
        </Button>
        <Menu
          elevation={0}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          id="lang-menu"
          MenuListProps={{
            'aria-labelledby': 'lang-button',
            sx: { background: '#fff' },
          }}
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
        >
          <MenuItem onClick={handleClose} disableRipple>
            Spanish
          </MenuItem>
        </Menu> */}
      </Toolbar>
    </AppBar>
  );
};
